<template>
  <!-- PC版本 -->
  <div v-if="!isMobile" class="w-full">
    <section class="h-[70vh] relative bg-cover bg-center bg-no-repeat"
      :style="{ backgroundImage: `url(${bannerOffers})` }">
      <div class="relative z-10 h-full flex items-center justify-start pl-[9%]">
        <h1 class="font-alibaba font-bold text-[3vw] text-white text-left w-[26vw]">
          {{ coreOffersTexts.hero?.title || 'Our Core Offers' }}
        </h1>
      </div>
    </section>

    <section class="h-screen flex justify-center bg-no-repeat bg-center bg-contain px-4"
      :style="{ backgroundImage: `url(${sourceandProcurement})` }">
      <div class="w-full grid grid-cols-3 gap-8 text-left mt-[6vw]">
        <div
          class="flex flex-col items-center text-gray-800 text-center sm:transform sm:translate-x-[20px] md:transform md:translate-x-[40px] lg:transform lg:translate-x-[50px] xl:transform xl:translate-x-[60px] 2xl:transform 2xl:translate-x-[70px] 3xl:transform 3xl:translate-x-[80px]">
          <img src="../assets/icn_offers_jp.png" alt="Supplier Icon" class="mb-4 w-[4.2vw] h-[4.2vw]" />
          <h3 class="font-bold text-[1.4vw]">
            {{ coreOffersTexts.sourcing?.features?.qualification?.title || 'Qualification' }}
          </h3>
          <p
            class="sm:mt-[8px] md:mt-[10px] lg:mt-[12px] w-[18vw] xl:mt-[14px] 2xl:mt-[16px] 3xl:mt-[18px] 4xl:mt-[20px] 5xl:mt-[22px] text-[1.1vw] 6xl:mt-[24px] font-medium text-[#666666] leading-[1.4]">
            {{ coreOffersTexts.sourcing?.features?.qualification?.description || '' }}
          </p>
        </div>

        <div class="flex flex-col items-center text-center">
          <div class="flex flex-col justify-center items-center">
            <h2
              class="sm:mt-[8px] md:mt-[12px] lg:mt-[16px] xl:mt-[20px] 2xl:mt-[22px] 3xl:mt-[23px] 4xl:mt-[24px] 5xl:mt-[24px] 6xl:mt-[26px] h-[92px] font-bold text-[1.8vw] text-[#0D0971] text-center font-[AlibabaPuHuiTi] w-[32vw]">
              {{ coreOffersTexts.sourcing?.title || 'Sourcing & Procurement from China' }}
            </h2>
            <p class="5xl:mt-10 text-black w-[22vw] text-[1.1vw] mt-[1vw] font-medium  leading-[1.4]">
              {{ coreOffersTexts.sourcing?.description || '' }}
            </p>
            <button
              class="w-[28vw] text-[1.6vw] font-bold text-white rounded-[20vw] bg-[#0D0971] pt-[1vw] pb-[1vw] px-[1vw] sm:mt-[16px] md:mt-[24px] lg:mt-[32px] xl:mt-[40px] 2xl:mt-[48px] 3xl:mt-[56px] 4xl:mt-[60px] 5xl:mt-[64px] 6xl:mt-[72px] leading-[1.2]"
              @click="goToSourceProduct" :style="buttonStyle" @mouseover="hovered = true" @mouseleave="hovered = false">
              {{ coreOffersTexts.sourcing?.button?.title || 'Sourcing Illustrations' }}<br>
              <span class="inline-block whitespace-nowrap">
                <span class="text-[1.2vw]">{{ commonTexts.click || 'Click' }} </span>
                <span class="text-[1.5vw] text-[#FEAE00] font-bold underline">{{ commonTexts.here || 'here' }} </span>
                <span class="text-[1.2vw]">{{ coreOffersTexts.sourcing?.button?.subtitle || 'for product information' }}</span>
              </span>
            </button>

            <div class="flex flex-col items-center text-gray-800 text-center mt-[7.6vw] 3xl:mt-[9.4vw]">
              <img src="../assets/icn_offers_cpo.png" alt="Traceability Icon" class="mb-4 w-[4.2vw] h-[4.2vw]" />
              <h3 class="font-bold text-[1.4vw]">
                {{ coreOffersTexts.sourcing?.features?.optimization?.title || 'Optimization' }}
              </h3>
              <p
                class="text-[1.1vw] w-[22vw] sm:mt-[8px] md:mt-[10px] g:mt-[12px] xl:mt-[14px] 2xl:mt-[16px] 3xl:mt-[18px] 4xl:mt-[20px] 5xl:mt-[22px] 6xl:mt-[24px] text-[#666666] font-medium leading-[1.4] ">
                {{ coreOffersTexts.sourcing?.features?.optimization?.description || '' }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="flex flex-col items-center text-gray-800 text-center sm:transform sm:translate-x-[-20px] md:transform md:translate-x-[-40px] lg:transform lg:translate-x-[-50px] xl:transform xl:translate-x-[-60px] 2xl:transform 2xl:translate-x-[-70px] 3xl:transform 3xl:translate-x-[-80px]">
          <img src="../assets/icn_offers_td.png" alt="Traceability Icon" class="mb-4 w-[4.2vw] h-[4.2vw]" />
          <h3 class="font-bold text-[1.4vw]">
            {{ coreOffersTexts.sourcing?.features?.traceability?.title || 'Traceability' }}
          </h3>
          <p class="text-[1.1vw] sm:mt-[8px] w-[18vw] md:mt-[10px] lg:mt-[12px] xl:mt-[14px] 2xl:mt-[16px] 3xl:mt-[18px] 4xl:mt-[20px] 5xl:mt-[22px] 6xl:mt-[24px] text-[#666666] font-medium"
            style="line-height: 1.2vw">
            {{ coreOffersTexts.sourcing?.features?.traceability?.description || '' }}
          </p>
        </div>
      </div>
    </section>

    <section class="h-screen flex justify-center items-center bg-no-repeat bg-cover text-white px-4"
      :style="{ backgroundImage: `url(${supply_chain})` }">
      <div class="w-full h-screen flex justify-center items-center">
        <div class="w-[45vw]  p-6 flex flex-col justify-center items-center">
          <div class="font-alibaba font-bold text-white text-[2.3vw] w-[70%] mx-auto text-left leading-[1.4]">
            {{ coreOffersTexts.logistics?.title || 'Logistics' }}
          </div>

          <p class="font-alibaba text-white text-left w-[70%] mt-[2vw] mx-auto text-[1.2vw] font-medium leading-[1.6]">
            {{ coreOffersTexts.logistics?.description || '' }}
          </p>
        </div>

        <div class="w-[55%] h-[65%] flex justify-between">
          <div class="relative w-[32%]  group " v-for="(card, index) in logisticsCards" :key="index">
            <img :src="card.img" class="object-cover h-full w-full rounded-[2.5vw]" :alt="card.alt" />

            <div
              class="absolute inset-0 z-10 bg-[rgba(169,107,0,0.7)] backdrop-blur-[15px] rounded-[2.5vw] flex flex-col items-center text-white opacity-100 pointer-events-auto">
              <div class="w-full flex justify-start px-[10%] mt-[2vw]">
                <img :src="card.icon" class="w-8 h-8 mb-4" />
              </div>
              <p class="text-[1.4vw] w-[80%] font-bold mb-2">
                {{ card.title }}
              </p>
              <p class="text-[1.2vw] w-[80%] font-medium  mt-0.8vw opacity-80 leading-[1.4]">
                {{ card.subTitle }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="h-screen flex flex-col w-full mx-auto bg-[#F3F8FF]">
      <div class="w-[81vw] mx-auto overflow-y-auto">
        <div class="text-center">
          <p class="text-left text-black font-bold text-[2.6vw] mt-3.0vw">
            {{ coreOffersTexts.salesService?.title || 'Sales Service' }}
          </p>
          <p class="text-left text-black mx-auto mt-[1.2vw] text-[1.2vw] font-medium leading-[1.4]">
            {{ coreOffersTexts.salesService?.description || '' }}
          </p>
        </div>

        <div class="grid grid-cols-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-[20px] mt-[2.2vw]">
          <div v-for="(item, index) in offerItems" :key="index" class="overflow-hidden flex flex-col"
            :style="getCardStyle(index)" @mouseover="hoveredIndex = index" @mouseleave="hoveredIndex = null">
            <img :src="item.img" :alt="item.title" class="aspect-[558/445] object-cover" />
            <div class="p-5 sm:p-6 flex-grow bg-white">
              <h3 class="font-bold text-[1.7vw] text-[#0D0971] text-left m-0">
                {{ item.title }}
              </h3>
              <p class="font-medium text-[1.2vw] text-[#666666] mt-[1vw] text-left leading-[1.4]">
                {{ item.text }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="h-screen flex flex-col items-center bg-no-repeat bg-cover text-white"
      :style="{ backgroundImage: `url(${bg_offer3})` }">
      <div class="w-[80%] mx-auto text-left">
        <p class="text-left text-white font-bold text-[2.6vw] mt-3.0vw">
          {{ coreOffersTexts.engineering?.title || 'Engineering' }}
        </p>
        <p class="text-left text-white mx-auto mt-[1.2vw]  text-[1.2vw] font-medium leading-[1.5]">
          {{ coreOffersTexts.engineering?.description || '' }}
        </p>

        <div class="flex justify-evenly items-center w-full mx-auto" style="margin-top: 62px">
          <div class="relative w-[18vw] aspect-square">
            <img src="../assets/img_offers_x.png" alt="Local Cost & International Standards"
              class="relative w-[18vw] rounded-full aspect-square object-cover" />
            <p class="sm:text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] 2xl:text-[21px] 3xl:text-[22px] 4xl:text-[24px] 5xl:text-[26px] 6xl:text-[28px] text-white font-bold w-[60%] m-auto text-center absolute inset-0 flex justify-center items-center"
              style="line-height: 2vw">
              {{ coreOffersTexts.engineering?.features?.fullCycle?.title || 'Full-Cycle Expertise' }}
            </p>
          </div>

          <div class="relative w-[22vw] aspect-square object-cover">
            <img src="../assets/img_offers_d.png" alt="Full-Cycle Expertise"
              class="w-[22vw] aspect-square object-cover rounded-full object-cover" />
            <p class="sm:text-[18px] md:text-[20px] lg:text-[24px] xl:text-[26px] 2xl:text-[28px] 3xl:text-[30px] 4xl:text-[32px] 5xl:text-[34px] 6xl:text-[36px] text-white text-white font-bold w-[60%] m-auto text-center absolute inset-0 flex justify-center items-center"
              style="line-height: 2vw">
              {{ coreOffersTexts.engineering?.features?.localCost?.title || 'Local Cost & International Standards' }}
            </p>
          </div>

          <div class="relative w-[18vw] rounded-full aspect-square">
            <img src="../assets/img_offers_x.png" alt="Feasible Solutions"
              class="relative w-[18vw] rounded-full aspect-square object-cover" />
            <p class="sm:text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] 2xl:text-[21px] 3xl:text-[22px] 4xl:text-[24px] 5xl:text-[26px] 6xl:text-[28px] text-white font-bold w-[60%] m-auto text-center absolute inset-0 flex justify-center items-center"
              style="line-height: 2vw">
              {{ coreOffersTexts.engineering?.features?.feasible?.title || 'Feasible Solutions' }}
            </p>
          </div>
        </div>
        <div class="flex justify-evenly w-full mx-auto mt-5vw">
          <div
            class="flex justify-center items-center w-[18vw] text-[1.2vw] font-medium leading-[1.3] text-center text-wrap break-words">
            {{ coreOffersTexts.engineering?.features?.fullCycle?.description || '' }}
          </div>
          <div
            class="flex justify-center items-center w-[22vw] text-[1.2vw] font-medium leading-[1.3] text-center text-wrap break-words">
            {{ coreOffersTexts.engineering?.features?.localCost?.description || '' }}
          </div>
          <div
            class="flex justify-center items-center w-[18vw] text-[1.2vw] font-medium leading-[1.3] text-center text-wrap break-words">
            {{ coreOffersTexts.engineering?.features?.feasible?.description || '' }}
          </div>
        </div>

      </div>
    </section>

    <section class="h-screen mx-auto text-black bg-[#F3F8FF]">
      <div class="w-[80%] mx-auto text-left">
        <p class="text-left text-black font-bold text-[2.6vw] mt-3.0vw">
          {{ coreOffersTexts.afterMarket?.title || 'After Market' }}
        </p>
        <p class="text-left text-black mx-auto mt-[1.2vw] text-[1.2vw] font-medium leading-[1.5]">
          {{ coreOffersTexts.afterMarket?.description || '' }}
        </p>

        <div class="flex flex-row flex-row mt-[50px]">
          <div
            class="sm:w-[80vw] md:w-[70vw] lg:w-[60vw] xl:w-[54vw] 2xl:w-[50vw] 3xl:w-[46vw] 4xl:w-[42vw] 5xl:w-[38vw] 6xl:w-[34vw] flex items-start justify-start">
            <img src="../assets/people.png" alt="After Market Service" class="object-cover rounded-lg shadow-lg" />
          </div>

          <div class="">
            <div class="flex flex-col items-end space-y-[20px]">
              <div v-for="(item, index) in contentList" :key="index"
                class="w-[83%] bg-white rounded-3xl shadow sm:p-[16px] md:p-[18px] lg:p-[22px] xl:p-[24px] 2xl:p-[26px] 3xl:p-[30px] 4xl:p-[34px] 5xl:p-[38px] 6xl:p-[42px]">
                <h3 class="font-bold text-[#0d0971] text-[1.5vw]">
                  {{ item.title }}
                </h3>
                <p class="text-[#666666] text-[1.2vw] font-medium mt-[1vw] leading-[1.5]">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- Mobile版本 -->
  <MobileCoreOffers v-if="isMobile" />
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import bannerOffers from "../assets/banner_offers.jpg";
import sourceandProcurement from "../assets/bg_offers_1.png";
import supply_chain from "../assets/bg_offers_2.jpg";
import bg_offer3 from "../assets/bg_offers_3.jpg";
import imgMae from "@/assets/img_offers_mae.png";
import imgTlp from "@/assets/img_offers_tlp.png";
import imgRdg from "@/assets/img_offers_rdg.png";
import { cards } from "../utils/imageData";
import { ref, onMounted, computed } from "vue";
import { pushToDataLayer } from '../utils/gtm';
import { useChatWidget } from '../utils/chatWidget';
import { useHead } from '@vueuse/head';
import { useI18n } from 'vue-i18n';
import { useDeviceDetection } from "@/utils/deviceDetection";
import MobileCoreOffers from "../components/MobileCoreOffers.vue";

const { isMobile } = useDeviceDetection();
const { locale, messages } = useI18n();

// 获取核心服务文本
const coreOffersTexts = computed(() => {
  return messages.value[locale.value]?.coreOffers || {};
});

// 获取通用文本
const commonTexts = computed(() => {
  return messages.value[locale.value]?.common || {
    click: 'Click',
    here: 'here'
  };
});

// 动态多语言 SEO
import { getSEO } from '../utils/seoConfig';
const seo = computed(() => getSEO(locale.value, 'coreOffers'));

useHead({
  title: computed(() => seo.value.title),
  meta: [
    { name: 'description', content: computed(() => seo.value.description) },
    { name: 'keywords', content: computed(() => seo.value.keywords) },
    { property: 'og:title', content: computed(() => seo.value.title) },
    { property: 'og:description', content: computed(() => seo.value.description) },
  ],
});

onMounted(() => {
  console.log('🔍 CoreOffers Debug Info:');
  console.log('Current locale:', locale.value);
  console.log('Available messages:', Object.keys(messages.value));
  console.log('Has coreOffers in current locale:', !!messages.value[locale.value]?.coreOffers);
  console.log('i18n instance:', { locale, messages });
  console.log('Test translation:', coreOffersTexts.value.engineering?.features?.feasible?.description);
  
  pushToDataLayer('page_view', {
    page_location: window.location.href,
    page_title: document.title,
    page_referrer: document.referrer,
  });
});

const router = useRouter();
const hovered = ref(false);
const { openChat } = useChatWidget();

const goToContactUs = () => {
  openChat("CoreOffers");
  pushToDataLayer("Chat_With_Us", {
    category: "CoreOffers",
    label: "Chat With Us",
  });
};

function goToSourceProduct() {
  router.push("/core-offers/source-product");
  pushToDataLayer("click", {
    category: "CoreOffers",
    label: "goToSourceProduct",
  });
}

const buttonStyle = computed(() => ({
  boxShadow: hovered.value ? "0px 0px 20px 0px #0D0971" : "none",
  transition: "box-shadow 0.3s ease",
}));

const hoveredIndex = ref<number | null>(null);

const getCardStyle = (index: number) => ({
  transition: "box-shadow 0.3s ease",
  boxShadow:
    hoveredIndex.value === index
      ? "0px 0px 20px 0px rgba(13, 9, 113, 0.3)"
      : "none",
});

// 获取国际化的数据
const offerItems = computed(() => {
  const salesService = coreOffersTexts.value.salesService?.items || {};
  return [
    {
      title: salesService.marketAccess?.title || 'Market Access',
      text: salesService.marketAccess?.text || '',
      img: imgMae,
    },
    {
      title: salesService.trustedPresence?.title || 'Trusted Presence',
      text: salesService.trustedPresence?.text || '',
      img: imgTlp,
    },
    {
      title: salesService.resultsGrowth?.title || 'Results Growth',
      text: salesService.resultsGrowth?.text || '',
      img: imgRdg,
    },
  ];
});

const contentList = computed(() => {
  const afterMarket = coreOffersTexts.value.afterMarket?.services || {};
  return [
    {
      title: afterMarket.rapidResponse?.title || 'Rapid Response',
      description: afterMarket.rapidResponse?.description || '',
    },
    {
      title: afterMarket.lifecycleValue?.title || 'Lifecycle Value',
      description: afterMarket.lifecycleValue?.description || '',
    },
    {
      title: afterMarket.seamlessSupport?.title || 'Seamless Support',
      description: afterMarket.seamlessSupport?.description || '',
    },
  ];
});

// 获取国际化的物流卡片数据
const logisticsCards = computed(() => {
  const logisticsData = coreOffersTexts.value.logistics?.cards || {};
  return [
    {
      img: cards[0].img,
      icon: cards[0].icon,
      title: logisticsData.endToEnd?.title || 'End to End',
      subTitle: logisticsData.endToEnd?.subtitle || '',
      alt: cards[0].alt,
    },
    {
      img: cards[1].img,
      icon: cards[1].icon,
      title: logisticsData.integrated?.title || 'Integrated',
      subTitle: logisticsData.integrated?.subtitle || '',
      alt: cards[1].alt,
    },
    {
      img: cards[2].img,
      icon: cards[2].icon,
      title: logisticsData.tailored?.title || 'Tailored',
      subTitle: logisticsData.tailored?.subtitle || '',
      alt: cards[2].alt,
    },
  ];
});
</script>

<style scoped>
/* Add optional custom styles here */
.inquery {
  position: fixed;
  right: 10px;
  top: 46%;
  z-index: 100;
  width: 5%;
}
</style>
